import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const LIST_ADMIN_USERS = "ADMIN-USER:LIST_ADMIN_USERS";

export interface ListAdminUsersAction extends Action {
  type: typeof LIST_ADMIN_USERS;
  organization: OrganizationKeyName;
}

export const listAdminUsersAction = (
  organization: OrganizationKeyName
): ListAdminUsersAction => ({
  type: LIST_ADMIN_USERS,
  organization,
});
